module.exports = __webpack_public_path__ + "static/media/celnova.63b6af02.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/labs/celnova.png
// module id = 124
// module chunks = 0